import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Handler} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {IconButton} from '../../../../../libs/shared/ui/src/components/buttons/iconButton';
import {fontSizes, fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';
import {flexCenter} from '../../../../../libs/shared/ui/src/styles/mixins';

/*
 * Props.
 */

interface RuleEditorSidePanelHeaderProps {
  isEditing: boolean;
  onDelete?: Handler;
  onClose: Handler;
}

/*
 * Styles.
 */

const StyledHeaderWrapper = styled.div`
  ${flexCenter}
  width: 100%;
  padding: 0 16px;
  justify-content: space-between;
  border-bottom: 1px solid ${(p) => p.theme.greys.shade30};

  h1 {
    color: ${(p) => p.theme.greys.shade70};
    font-size: ${fontSizes.large};
    font-weight: ${fontWeights.medium};
  }
`;

const StyledButtonsWrapper = styled.div`
  ${flexCenter};
`;

/*
 * Component.
 */

export const RuleEditorSidePanelHeader: FC<RuleEditorSidePanelHeaderProps> = ({
  onClose,
  onDelete,
  isEditing,
}) => (
  <StyledHeaderWrapper>
    <h1>
      {isEditing ? (
        <Trans id="rule-editor-side-panel-header-edit">Edit dynamic variable</Trans>
      ) : (
        <Trans id="rule-editor-side-panel-header-new">New dynamic variable</Trans>
      )}
    </h1>
    <StyledButtonsWrapper>
      {onDelete && (
        <IconButton
          onClick={onDelete}
          iconName="trash"
          label={<Trans id="drawer-header-delete">Delete</Trans>}
        />
      )}
      <IconButton iconName="close" onClick={onClose} label={<Trans id="drawer-header-close">Close</Trans>} />
    </StyledButtonsWrapper>
  </StyledHeaderWrapper>
);
